import { ReactNode } from "react";


export function DateDisplayer({children} : {children: ReactNode[]}) {

    return (
        <div className="flex justify-between w-full p-4">
            {children.map((child : ReactNode) => <div className="p-2">{child}</div>)}
        </div>
    )


}